import React from 'react';
import { Container } from 'reactstrap';
import BrandListViewItem from '../BrandListViewItem';
import HorizontalSlider from '../HorizontalSlider';
import SkeletonItems from './SkeletonItems';
import { BrandReadModel } from '~types/api';

const BrandSlider: React.FC<{
  isLoading?: boolean;
  brands?: BrandReadModel[];
  title?: string;
}> = ({ isLoading, brands, title }) => {
  if (isLoading) {
    return <SkeletonItems />;
  }

  if (!brands?.length) {
    return null;
  }

  return (
    <Container>
      <h5 className="font-weight-bold">{title}</h5>
      <HorizontalSlider xs={2}>
        {brands.map((brand) => (
          <BrandListViewItem brand={brand} />
        ))}
      </HorizontalSlider>
    </Container>
  );
};

export default BrandSlider;
